<template>
  <nav class="footer-nav">
    <div v-if="!tree">No NavigationTree</div>
    <template v-if="tree">
      <ul v-for="category in tree" :key="category.position" :data-sort="category.position" class="nav-set"
          :class="navsetclass">
        <!-- PARENT ITEM -->
        <li class="nav-item first" data-sort="0" :class="navitemclass">
          <NuxtLink :to="basedir + category.url" :title="category.name" target="_self" class="nav-link" :class="navlinkclass" :external="external">
            {{ category.name }}
          </NuxtLink>
        </li>
        <!-- Child Item -->
        <template v-for="(childcategory, key) in category.descendants">
          <li v-if="key <= limit" class="nav-item" :class="navitemclass" :key="childcategory.position"
              :data-sort="childcategory.position">
            <NuxtLink v-if="key < limit" :to="basedir + category.url + '/' + childcategory.url" :title="childcategory.name"
                      target="_self" class="nav-link" :class="navlinkclass" :data-key="key" :data-limit="limit" :external="external">
              {{ childcategory.name }}
            </NuxtLink>
            <NuxtLink v-else :to="basedir + category.url" :title="category.name" :aria-label="category.name" target="_self" class="nav-link" :class="morenavitemclass"
                      :data-key="key" :data-limit="limit" :external="external">
              {{ moretitle }}
            </NuxtLink>
          </li>
        </template>
      </ul>
    </template>
  </nav>
</template>
<script lang="ts" setup>
const props = defineProps({
  tree: {
    type: Object,
  },
  /** Limit of CHild ELEM */
  limit: {
    type: Number,
    required: true
  },
  moretitle: {
    type: String,
    required: true
  },
  navclass: {
    type: String,
    required: false
  },
  basedir: {
    type: String,
    required: true,
    default: '/',
  },
  external: {
    type: Boolean,
    default: false
  },
  navsetclass: String,
  navitemclass: String,
  morenavitemclass: String,
  navlinkclass: String,
})
</script>
